
export const EVENT_STUB = 'EVENT_STUB';

export const SNACKBAR_SHOW = 'SNACKBAR_SHOW';

// Invoice Edit Form
export const OPEN_INVOICE_EDIT_FORM = 'OPEN_INVOICE_EDIT_FORM';
export const CLOSE_INVOICE_EDIT_FORM = 'CLOSE_INVOICE_EDIT_FORM';
/**
 * Items table row in invoice edit form activated.
 * @type {string}
 */
export const ITEM_ROW_ACTIVATED = 'ITEM_ROW_ACTIVATED';

/**
 * Licenses table row in invoice edit form activated.
 * @type {string}
 */
export const LICENSE_ROW_ACTIVATED = 'LICENSE_ROW_ACTIVATED';

export const RELOAD_INVOICE_ITEMS_TABLE = 'RELOAD_INVOICE_ITEMS_TABLE';

export const RELOAD_INVOICE_LICENSES_TABLE = 'RELOAD_INVOICE_LICENSES_TABLE';


// Navigation drawer
export const OPEN_DRAWER = 'OPEN_DRAWER';

// Departments
export const DEPARTMENT_CREATED = 'DEPARTMENT_CREATED';

// Transfers
export const TRANSFER_CREATED = 'TRANSFER_CREATED';

// Hardware Models
export const HARDWARE_MODEL_CREATED = 'HARDWARE_MODEL_CREATED';

// Invoices
export const INVOICE_CREATED = 'INVOICE_CREATED';
export const RELOAD_INVOICES_TABLE = 'RELOAD_INVOICES_TABLE';
export const RELOAD_INVOICE_FULL_DATA = 'RELOAD_INVOICE_FULL_DATA';

// Providers
export const PROVIDER_CREATED = 'PROVIDER_CREATED';

// Repairs
export const REPAIR_CREATED = 'REPAIR_CREATED';

// Types
export const TYPE_CREATED = 'TYPE_CREATED';

// Users
export const GOOGLE_WORKSPACE_USERS_LOADED = 'GOOGLE_WORKSPACE_USERS_LOADED';
export const USER_CREATED = 'USER_CREATED';

// Roles
export const ROLE_CREATED = 'ROLE_CREATED';
